import type { CityConfig } from "../city-template/types";

export const shivelyConfig: CityConfig = {
  city: "Shively",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "shively",
  route: "/shively",
  title: "Emergency Passport Shively, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Shively, KY — as fast as 24 hours. Fast passport renewal and same-day help for Louisville West, Valley Station, and the Dixie Highway corridor. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency \u0026 Expedited Passport Services in Shively, KY",
  heroSubtitle: "Need an emergency passport fast from Louisville West? Fast Passport Center helps Shively and Louisville West travelers get expedited passports as quickly as 24 hours. Serving the Dixie Highway corridor, Valley Station, and the southwestern Jefferson County communities. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Shively Kentucky suburban Louisville West residential district, clean suburban neighborhood with tree-lined streets and modest homes, wide panoramic view of southwestern Jefferson County Kentucky community, bright daytime photography, no visible text or people",
  "width": 1800,
  "height": 700,
  "seq": "shively-hero-001",
  "orientation": "landscape",
  "heroImageAlt": "Shively Kentucky suburban Louisville West residential district",
  "geoPosition": "38.2001;-85.8227",
  "geoPlacename": "Shively, Kentucky",
  "lastModified": "2026-05-29",
  "regionalAgency": {
    "name": "Chicago Passport Agency",
    "address": "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    "distance": "Located in downtown Chicago — approximately 290 miles from Shively via I-65"
  },
  "nearbyCitiesZips": [
    { "name": "Shively", "zips": "40216, 40256" },
    { "name": "Valley Station", "zips": "40272, 40214" },
    { "name": "Pleasure Ridge Park", "zips": "40258" },
    { "name": "Algonquin", "zips": "40214" },
    { "name": "Iroquois", "zips": "40214, 40215" },
    { "name": "Fairdale", "zips": "40118" },
    { "name": "Park Hill", "zips": "40214" },
    { "name": "South Louisville", "zips": "40215, 40216" },
    { "name": "Lynnview", "zips": "40216" },
    { "name": "Audubon Park", "zips": "40213" },
    { "name": "Kosciusko", "zips": "40215" },
    { "name": "Bullitt County", "zips": "40165, 40166" }
  ],
  "benefits": [
    { "icon": "ri-time-line", "title": "24–48 Hour Processing", "desc": "Emergency courier for urgent Louisville West departures" },
    { "icon": "ri-shield-check-line", "title": "Registered Courier", "desc": "U.S. Department of State approved passport expediting" },
    { "icon": "ri-user-line", "title": "Dedicated Agent", "desc": "A real person assigned to your Shively case start to finish" },
    { "icon": "ri-mail-send-line", "title": "Document Shipping", "desc": "Prepaid overnight labels from any UPS in southwestern Jefferson County" }
  ],
  "internalLinks": [
    { "name": "Emergency passport services in Louisville", "route": "/louisville" },
    { "name": "Expedited passport renewal in Lexington", "route": "/lexington" },
    { "name": "Fast passport services in Bardstown", "route": "/cities/bardstown" },
    { "name": "Same-day passport help in Elizabethtown", "route": "/elizabethtown" },
    { "name": "Urgent passport services in Bowling Green", "route": "/cities/bowling-green" },
    { "name": "Emergency passport help in Frankfort", "route": "/frankfort" }
  ],
  "fpcOfficeNote": "Fast Passport Center serves Shively remotely via secure courier. We do not have a walk-in office on Dixie Highway — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Louisville West travelers.",
  "fpcOfficeDistance": "Serving all of Shively, Valley Station, Pleasure Ridge Park, and the southwestern Jefferson County corridor",
  "serviceAreaIntro": "From the Dixie Highway corridor to Valley Station, from Pleasure Ridge Park to Fairdale — Fast Passport Center serves the entire Louisville West and southwestern Jefferson County area.",
  "nearbyCitiesIntro": "We serve all Shively neighborhoods and nearby communities including Valley Station, Pleasure Ridge Park, Algonquin, Iroquois, Fairdale, Park Hill, South Louisville, Lynnview, Audubon Park, Kosciusko, and the greater Louisville West corridor. If you are in southwestern Jefferson County, we have you covered.",
  "howItWorksIntro": "Most Shively travelers complete everything online and ship documents overnight from the nearest UPS. No need to drive to Chicago or wait in line at the regional agency.",
  "mistakesIntro": "Louisville West travelers often underestimate how long passport processing takes. Here are the most common mistakes that cause delays.",
  "testimonialsIntro": "Shively and Louisville West travelers trust us when their departure is days away. Here is what some of them have to say.",
  "faqIntro": "Have questions about expedited passports in Shively? Here are the most common ones we hear from Louisville West and southwestern Jefferson County travelers.",
  "statePageRoute": "/states/kentucky",
  "statePageName": "Kentucky",
  "stickyNavLinks": [
    { "label": "Processing", "href": "#processing-options" },
    { "label": "Services", "href": "#services" },
    { "label": "Service Area", "href": "#service-area" },
    { "label": "Facilities", "href": "#acceptance-facilities" },
    { "label": "Comparison", "href": "#comparison" },
    { "label": "How It Works", "href": "#how-it-works" },
    { "label": "FAQ", "href": "#faq" },
    { "label": "Resources", "href": "#local-resources" }
  ],
  "processingOptions": [
    {
      "speed": "2–9",
      "unit": "Business Days",
      "label": "Fast Passport Center",
      "tag": "Most Popular",
      "tagColor": "bg-[#F6C344] text-[#1A365D]",
      "features": [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission slots",
        "Predictable turnaround for Louisville West travelers",
        "Ideal for upcoming business or leisure travel",
        "Full document review included",
        "Dedicated agent assigned to your Shively case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns"
      ],
      "highlight": true
    },
    {
      "speed": "3–5",
      "unit": "Weeks",
      "label": "Fast Passport Center",
      "tag": "Standard Expedited",
      "tagColor": "bg-[#1A365D]/10 text-[#1A365D]",
      "features": [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service mail options",
        "Good for planned travel in the next few months",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns"
      ],
      "highlight": false,
      "smartSaver": true
    },
    {
      "speed": "1–3",
      "unit": "Months",
      "label": "Self-Service (Post Office)",
      "tag": "Slowest",
      "tagColor": "bg-gray-100 text-gray-400",
      "features": [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Cannot upgrade speed after submission"
      ],
      "highlight": false,
      "muted": true
    },
    {
      "speed": "24",
      "unit": "Hours*",
      "label": "Regional Agency Processing",
      "tag": "Emergency Only",
      "tagColor": "bg-gray-100 text-gray-500",
      "features": [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Medical crisis documentation required",
        "Long wait at Chicago — over 4 hours from Shively"
      ],
      "highlight": false,
      "emergency": true
    }
  ],
  "services": [
    {
      "icon": "ri-flashlight-line",
      "title": "Emergency Passport",
      "description": "For Louisville West travelers with immediate departure needs — as fast as 24 hours for urgent southwestern Jefferson County international flights.",
      "bullets": ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      "badge": "Most Popular",
      "link": "https://fastpassportcenter.com/checkout/?passport=new-passport"
    },
    {
      "icon": "ri-passport-line",
      "title": "Passport Renewal",
      "description": "Fast renewal for Shively adults with a passport issued within the last 15 years at age 16 or older.",
      "bullets": ["No clerk visit required for most renewals", "Mail-in or courier options", "Lost passport replacement available"],
      "badge": null,
      "link": "https://fastpassportcenter.com/checkout/?passport=passport-renewal"
    },
    {
      "icon": "ri-add-circle-line",
      "title": "New Passport",
      "description": "First-time passport application guidance with local acceptance clerk support for Shively applicants.",
      "bullets": ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      "badge": null,
      "link": "https://fastpassportcenter.com/checkout/?passport=new-passport"
    },
    {
      "icon": "ri-alert-line",
      "title": "Lost or Stolen Passport",
      "description": "Emergency replacement for Shively residents with DS-64 form guidance and police documentation support.",
      "bullets": ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      "badge": "Urgent",
      "link": "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport"
    },
    {
      "icon": "ri-parent-line",
      "title": "Child Passport",
      "description": "Passport services for minors with parental consent and acceptance clerk support near Shively.",
      "bullets": ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      "badge": null,
      "link": "https://fastpassportcenter.com/checkout/?passport=child-passport"
    },
    {
      "icon": "ri-file-edit-line",
      "title": "Name Change",
      "description": "Passport correction and name change service after marriage, divorce, or legal changes for Shively residents.",
      "bullets": ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      "badge": null,
      "link": "https://fastpassportcenter.com/checkout/?passport=name-change"
    }
  ],
  "servicesSchema": [
    { "name": "Emergency Passport Shively", "description": "Urgent 24-hour passport processing for Shively and Louisville West travelers with immediate international departure needs." },
    { "name": "Passport Renewal Shively", "description": "Fast passport renewal for Shively residents with passport issued in last 15 years at age 16 or older." },
    { "name": "New Passport Shively", "description": "First-time passport application assistance for Shively and Louisville West residents." },
    { "name": "Lost Passport Replacement Shively", "description": "Emergency passport replacement for lost or stolen passports in southwestern Jefferson County." },
    { "name": "Child Passport Shively", "description": "Passport services for minors in Shively with parental consent and acceptance clerk support." },
    { "name": "Name Change Passport Shively", "description": "Passport name change after marriage, divorce, or legal name changes for Shively residents." }
  ],
  "testimonials": [
    {
      "name": "Deborah S.",
      "location": "Shively, KY",
      "rating": 5,
      "text": "My passport expired right before a family trip to Jamaica. I didn't think I could get it renewed in time from the Shively area. Fast Passport Center handled everything in 5 days. So glad I didn't have to drive to Chicago.",
      "service": "Passport Renewal"
    },
    {
      "name": "Charles R.",
      "location": "Valley Station, KY",
      "rating": 5,
      "text": "Working long hours at the Ford plant, I needed a service that didn't require me to take time off. Fast Passport Center let me do everything online and drop documents at UPS. My passport arrived in 4 days for a business trip to Canada.",
      "service": "Passport Renewal"
    },
    {
      "name": "Angela T.",
      "location": "Shively, KY",
      "rating": 5,
      "text": "My daughter's passport was missing two weeks before our cruise to the Bahamas. Fast Passport Center helped us file a lost passport report and got her a replacement in 36 hours. The kids were so relieved we could still go.",
      "service": "Lost Passport"
    },
    {
      "name": "Michael J.",
      "location": "Pleasure Ridge Park, KY",
      "rating": 5,
      "text": "First-time passport for my cruise to the Caribbean. I had no idea what I was doing. Fast Passport Center walked me through every step, found the nearest acceptance facility, and my passport arrived in 5 days. Excellent service.",
      "service": "New Passport"
    }
  ],
  "facilities": [
    {
      "id": "shively-1",
      "name": "Shively Post Office",
      "type": "USPS Passport Acceptance Facility",
      "address": "3620 Dixie Hwy",
      "city": "Louisville",
      "state": "KY",
      "zip": "40216",
      "phone": "(502) 447-1521",
      "hours": "Mon–Fri: 9:00 AM – 4:00 PM",
      "distance": "Main post office for Shively residents",
      "website": "https://tools.usps.com/find-location.htm",
      "websiteLabel": "USPS Location Finder",
      "notes": "Primary Shively location. Appointments strongly recommended. Full passport acceptance services.",
      "icon": "ri-mail-line"
    },
    {
      "id": "shively-2",
      "name": "Valley Station Post Office",
      "type": "USPS Passport Acceptance Facility",
      "address": "10303 Dixie Hwy",
      "city": "Louisville",
      "state": "KY",
      "zip": "40272",
      "phone": "(502) 935-1521",
      "hours": "Mon–Fri: 9:00 AM – 4:00 PM",
      "distance": "Approximately 3 miles from central Shively",
      "website": "https://tools.usps.com/find-location.htm",
      "websiteLabel": "USPS Location Finder",
      "notes": "Serves Valley Station and southwestern Louisville. Good alternative for Shively residents.",
      "icon": "ri-mail-line"
    },
    {
      "id": "shively-3",
      "name": "Louisville Main Post Office",
      "type": "USPS Passport Acceptance Facility",
      "address": "1420 W Liberty St",
      "city": "Louisville",
      "state": "KY",
      "zip": "40203",
      "phone": "(502) 582-1431",
      "hours": "Mon–Fri: 9:00 AM – 4:00 PM",
      "distance": "Approximately 10 miles from Shively",
      "website": "https://tools.usps.com/find-location.htm",
      "websiteLabel": "USPS Location Finder",
      "notes": "Major downtown Louisville facility. Good for Shively residents with downtown commutes.",
      "icon": "ri-mail-line"
    },
    {
      "id": "shively-4",
      "name": "Okolona Post Office",
      "type": "USPS Passport Acceptance Facility",
      "address": "7701 Preston Hwy",
      "city": "Louisville",
      "state": "KY",
      "zip": "40219",
      "phone": "(502) 968-1521",
      "hours": "Mon–Fri: 9:00 AM – 4:00 PM",
      "distance": "Approximately 6 miles from Shively",
      "website": "https://tools.usps.com/find-location.htm",
      "websiteLabel": "USPS Location Finder",
      "notes": "Serves South Louisville and Okolona. Good alternative when Shively PO is fully booked.",
      "icon": "ri-mail-line"
    },
    {
      "id": "shively-5",
      "name": "Fairdale Post Office",
      "type": "USPS Passport Acceptance Facility",
      "address": "4010 Fairdale Rd",
      "city": "Louisville",
      "state": "KY",
      "zip": "40118",
      "phone": "(502) 937-1521",
      "hours": "Mon–Fri: 9:00 AM – 4:00 PM",
      "distance": "Approximately 4 miles from Shively",
      "website": "https://tools.usps.com/find-location.htm",
      "websiteLabel": "USPS Location Finder",
      "notes": "Serves Fairdale and southwestern Louisville. Photo services available.",
      "icon": "ri-mail-line"
    },
    {
      "id": "shively-6",
      "name": "Jefferson County Clerk — Main Office",
      "type": "County Clerk Passport Acceptance",
      "address": "527 W Jefferson St",
      "city": "Louisville",
      "state": "KY",
      "zip": "40202",
      "phone": "(502) 574-5130",
      "hours": "Mon–Fri: 8:00 AM – 4:30 PM",
      "distance": "Approximately 10 miles from Shively",
      "website": "https://jeffersonclerk.com/",
      "websiteLabel": "Jefferson County Clerk",
      "notes": "Full-service county clerk for Jefferson County. Can process passport acceptance applications.",
      "icon": "ri-government-line"
    }
  ],
  "comparisonRows": [
    { "feature": "Appointment Needed", "agency": "Yes — call NPIC, very limited", "fpc": "No — we handle everything" },
    { "feature": "Processing Speed", "agency": "Same-day only for emergencies", "fpc": "24–48 hours for emergency" },
    { "feature": "Document Review", "agency": "No — rejections sent back", "fpc": "Yes — full review before submission" },
    { "feature": "Travel Required", "agency": "Yes — 5+ hour drive to Chicago", "fpc": "No — ship from home or Louisville" },
    { "feature": "Agent Support", "agency": "Government clerk, no follow-up", "fpc": "Yes — dedicated agent" },
    { "feature": "Status Updates", "agency": "No tracking provided", "fpc": "Daily email updates" },
    { "feature": "Guaranteed Timing", "agency": "No — subject to availability", "fpc": "Yes — contractual turnaround" }
  ],
  "mistakes": [
    {
      "icon": "ri-image-line",
      "title": "Incorrect Photo Dimensions",
      "description": "Many Louisville West photo shops don't know the exact 2×2 inch passport requirement. Photos must have a plain white or off-white background — no patterns, no glasses.",
    },
    {
      "icon": "ri-file-list-line",
      "title": "Pre-Signed DS-11 Form",
      "description": "The number one reason for rejection at Louisville West acceptance facilities. The clerk must witness you sign the DS-11 in person — never sign it before arriving.",
    },
    {
      "icon": "ri-money-dollar-circle-line",
      "title": "Wrong Fee Payment",
      "description": "Passport fees change frequently. Shively applicants often arrive with outdated checks. We provide the exact current fee breakdown so you never have to reschedule.",
    },
    {
      "icon": "ri-calendar-close-line",
      "title": "No Travel Documentation",
      "description": "Without confirmed flight details, the Chicago agency won't grant an emergency appointment. Always have your booking ready for verification.",
    },
    {
      "icon": "ri-parent-line",
      "title": "Missing Parental Consent",
      "description": "Both parents must appear with a minor or submit notarized DS-3053. Many southwestern Louisville families get caught off guard at the clerk.",
    },
    {
      "icon": "ri-time-line",
      "title": "Waiting Too Long",
      "description": "Standard processing takes 8–11 weeks. Many Louisville West travelers assume they have plenty of time. Start expedited at least 3 weeks before international travel.",
    },
  ],
  "steps": [
    { "number": "1", "icon": "ri-file-list-line", "title": "Apply Online", "description": "Complete your application on our secure website in under 10 minutes from anywhere in Shively or Louisville West." },
    { "number": "2", "icon": "ri-mail-send-line", "title": "Ship Documents", "description": "We email you a prepaid overnight label. Drop your documents at any UPS location in southwestern Jefferson County." },
    { "number": "3", "icon": "ri-shield-check-line", "title": "We Review", "description": "Our team checks every document for accuracy before hand-delivering to the U.S. Department of State." },
    { "number": "4", "icon": "ri-passport-line", "title": "Processing", "description": "Your passport is processed at a State Department facility using our registered courier slots — no postal delays." },
    { "number": "5", "icon": "ri-truck-line", "title": "Delivery", "description": "We overnight your new passport to your Shively or Louisville West address — fully trackable every step of the way." },
  ],
  "faqs": [
    { "q": "Can I get an emergency passport in Shively, KY?", "a": "Yes. Fast Passport Center provides emergency passport services for Shively and Louisville West travelers. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Chicago." },
    { "q": "How fast can I renew my passport near Shively?", "a": "With Fast Passport Center, Shively travelers can get a passport renewed in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day option is the most popular. Both options include document review and a dedicated agent." },
    { "q": "Where is the nearest passport acceptance facility to Shively?", "a": "The most convenient options for Shively residents are the Shively Post Office (3620 Dixie Hwy), the Valley Station Post Office (10303 Dixie Hwy), and the Okolona Post Office (7701 Preston Hwy). All require appointments — we can help you find availability." },
    { "q": "Do I need to drive to Chicago for an expedited passport from Shively?", "a": "No. With Fast Passport Center, you complete everything online and ship your documents via prepaid overnight label. Our registered couriers handle the in-person delivery to State Department facilities — you stay in Louisville West and we do the rest." },
    { "q": "Can I get a same-day passport from Shively?", "a": "Same-day passports from the Chicago Regional Passport Agency are only for life-or-death emergencies — and require proof of travel within 72 hours plus a 5-hour drive. For nearly all Shively urgent travel needs, our 24–48 hour emergency courier service is the best option." },
    { "q": "How do I get a child passport in Shively, KY?", "a": "For child passports in Shively, both parents must appear at an acceptance facility or submit notarized DS-3053 consent. We walk Louisville West families through the entire process, including appointment scheduling at the nearest facility." },
    { "q": "What if I lost my passport before a trip from Shively?", "a": "Contact Fast Passport Center immediately. We provide lost passport replacement services for Shively residents with DS-64 form guidance and emergency courier processing. We can get your replacement in 24–48 hours so you don't miss your departure." },
    { "q": "How much does expedited passport service cost near Shively?", "a": "Government fees are fixed: $130 for an adult passport book plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline." },
    { "q": "What documents do I need for a first-time passport in Shively?", "a": "You need proof of citizenship (birth certificate), government-issued photo ID, two passport photos, and payment. First-time applicants must visit an acceptance clerk in person. We provide a full checklist and review your documents beforehand." },
    { "q": "Is there a passport photo service near Shively?", "a": "Yes — CVS at 7601 Dixie Hwy, Walgreens on 3rd Street Road, and Walmart on Outer Loop all offer passport photos near Shively. We review your photos before submission to ensure they meet State Department standards." },
    { "q": "Can Shively business travelers use your service?", "a": "Absolutely. Many of our Louisville West clients work along the Dixie Highway corridor and need passports for business travel. We specialize in fast turnaround that accommodates professional schedules — complete everything online, ship overnight, receive your passport at your door." },
    { "q": "How long does passport renewal take for Shively residents?", "a": "With Fast Passport Center, Shively passport renewal takes 3–5 business days with our standard expedited option, or 24–48 hours with emergency processing. Standard government mail takes 8–11 weeks — not reliable for most Shively travel timelines." },
    { "q": "What is the fastest passport service available in Shively, KY?", "a": "The fastest option is Fast Passport Center's 24–48 hour emergency courier service. We hand-deliver your documents directly to a U.S. Department of State processing facility, bypassing mail queues and postal delays that affect standard applications." },
    { "q": "Can I use your service if my passport expires soon before a cruise?", "a": "Yes. If your passport is expiring soon, contact us immediately. Cruise lines require your passport to be valid at least 6 months past your return date. We can expedite renewal for Shively residents in 24–48 hours — enough time for most upcoming cruises." },
    { "q": "What neighborhoods near Shively do you serve?", "a": "We serve all of Shively and the surrounding Louisville West communities including Valley Station, Pleasure Ridge Park, Algonquin, Iroquois, Fairdale, Park Hill, South Louisville, Lynnview, Audubon Park, Kosciusko, and the greater southwestern Jefferson County corridor." },
  ],
  "photoLocations": [
    { "name": "CVS Pharmacy — Shively", "address": "7601 Dixie Hwy, Louisville, KY 40258", "hours": "Mon–Sun: 8AM–10PM" },
    { "name": "Walgreens — Louisville West", "address": "3901 3rd Street Rd, Louisville, KY 40214", "hours": "Mon–Sun: 7AM–11PM" },
    { "name": "Walmart — Outer Loop", "address": "7100 Raggard Rd, Louisville, KY 40216", "hours": "Mon–Sun: 6AM–11PM" },
    { "name": "CVS Pharmacy — Valley Station", "address": "10317 Dixie Hwy, Louisville, KY 40272", "hours": "Mon–Sun: 8AM–10PM" },
    { "name": "Walgreens — Preston Hwy", "address": "7701 Preston Hwy, Louisville, KY 40219", "hours": "Mon–Sun: 7AM–11PM" },
    { "name": "Rite Aid — Fairdale", "address": "3935 Fairdale Rd, Louisville, KY 40118", "hours": "Mon–Sun: 8AM–10PM" },
  ],
  "dmvLocations": [
    {
      "name": "Jefferson County Circuit Court Clerk",
      "address": "527 W Jefferson St, Louisville, KY 40202",
      "hours": "Mon–Fri: 8AM–4:30PM",
      "note": "Main clerk office for Jefferson County. Handles REAL ID and driver's license renewals. Appointment recommended.",
      "featured": true,
    },
    {
      "name": "Jefferson County Clerk — South Office",
      "address": "3820 Valley Station Rd, Louisville, KY 40272",
      "hours": "Mon–Fri: 8AM–4:00PM",
      "note": "South office convenient for Shively, Valley Station, and Fairdale residents. Walk-ins welcome.",
      "featured": true,
    },
    {
      "name": "Jefferson County Clerk — Westport Road",
      "address": "9110 Westport Rd, Louisville, KY 40242",
      "hours": "Mon–Fri: 8AM–4:00PM",
      "note": "Alternative for West Louisville and Shively residents. Appointment recommended.",
      "featured": false,
    },
  ],
  "airports": [
    {
      "code": "SDF",
      "name": "Louisville Muhammad Ali International",
      "distance": "15 miles from Shively",
      "address": "600 Terminal Dr, Louisville, KY 40209",
      "note": "The primary airport for Louisville West travelers. Domestic flights with connections to major international hubs. Approximately 20 minutes from Shively via I-264.",
      "flightUrl": "https://www.flylouisville.com/",
      "flightLabel": "Louisville Airport",
      "featured": true,
    },
    {
      "code": "LEX",
      "name": "Blue Grass Airport (Lexington)",
      "distance": "85 miles from Shively",
      "address": "4000 Terminal Dr, Lexington, KY 40510",
      "note": "Alternative regional airport about 1.5 hours from Shively via I-64.",
      "flightUrl": "https://www.bluegrassairport.com/",
      "flightLabel": "Blue Grass Airport",
      "featured": false,
    },
    {
      "code": "CVG",
      "name": "Cincinnati/Northern Kentucky International",
      "distance": "110 miles from Shively",
      "address": "3087 Terminal Dr, Hebron, KY 41048",
      "note": "Major international hub for long-haul flights. Accessible via I-71 from Shively.",
      "flightUrl": "https://www.cvgairport.com/",
      "flightLabel": "CVG Airport",
      "featured": false,
    },
  ],
}